import { Hero } from "@/components/Hero";
import { Problem } from "@/components/Problem";
import { TargetAudience } from "@/components/TargetAudience";
import { Solution } from "@/components/Solution";
import { HowItWorks } from "@/components/HowItWorks";
import { Features } from "@/components/Features";
import { Privacy } from "@/components/Privacy";
import { TrustBadges } from "@/components/TrustBadges";
import { StatsCounter } from "@/components/StatsCounter";
import { CTA } from "@/components/CTA";
import { Footer } from "@/components/Footer";
import { Navbar } from "@/components/Navbar";
import { ScrollProgress } from "@/components/ScrollProgress";
import { BackToTop } from "@/components/BackToTop";
import { SectionDivider } from "@/components/SectionDivider";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";


const Index = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  // Redirect authenticated users to settings
  useEffect(() => {
    if (user) {
      navigate('/settings', { replace: true });
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen" id="main-content">
      <ScrollProgress />
      <Navbar />
      <Hero />
      <SectionDivider variant="wave" fillClassName="fill-muted/30" />
      <Problem />
      <SectionDivider variant="curve" flip fillClassName="fill-muted/30" />
      <TargetAudience />
      <SectionDivider variant="wave" fillClassName="fill-background" />
      <Solution />
      <SectionDivider variant="wave" fillClassName="fill-muted/50" />
      <HowItWorks />
      <SectionDivider variant="curve" flip fillClassName="fill-background" />
      <Features />
      <SectionDivider variant="wave" fillClassName="fill-muted/30" />
      <Privacy />
      <SectionDivider variant="curve" flip fillClassName="fill-muted/30" />
      <TrustBadges />
      <SectionDivider variant="wave" fillClassName="fill-background" />
      <StatsCounter />
      <SectionDivider variant="curve" flip fillClassName="fill-background" />
      <CTA />
      <Footer />
      <BackToTop />
    </div>
  );
};

export default Index;
